var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14.1841V45.1311L30.2892 55L54 45.1311L54 14.1841L30.2891 7L6 14.1841Z",
    fill: "#204751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71637 13.2252L5 13.4371V14.1841V45.1311V45.8042L5.62358 46.0576L29.9127 55.9264L30.2937 56.0813L30.6734 55.9232L54.3843 46.0543L55 45.7981V45.1311L55 14.1841V13.4422L54.29 13.2271L30.5791 6.04296L30.2926 5.95615L30.0055 6.04107L5.71637 13.2252Z",
    stroke: "#56A8BD",
    strokeOpacity: 0.62,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8333 33.7288C44.8333 32.5539 43.9403 31.5976 42.8383 31.5976H26.9037C25.8017 31.5976 24.9087 32.5539 24.9087 33.7288C24.9087 34.9036 25.8001 35.8599 26.9037 35.8599H42.8383C43.9403 35.8615 44.8333 34.9052 44.8333 33.7288Z",
    fill: "#B3B1B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5132 39.796L22.3421 46.7009C23.8827 48.251 26.0122 48.9999 28.3635 48.9999C30.7147 48.9999 32.8443 48.1893 34.3881 46.6344L38.4857 42.4592C39.2932 41.6453 39.2647 40.2979 38.424 39.4508C37.5832 38.6038 36.2469 38.5753 35.441 39.3891L31.204 43.5168C30.4725 44.2563 29.4592 44.565 28.3397 44.565C27.2203 44.565 26.2086 44.2563 25.4739 43.5168L18.6687 36.6088C17.9357 35.8693 17.5667 34.7879 17.5667 33.659C17.5667 32.5301 17.9357 31.5104 18.6687 30.771L25.4533 23.836C26.1864 23.0966 27.2203 22.8148 28.3382 22.8148C29.456 22.8148 30.4693 23.1235 31.2024 23.8629L35.4394 27.9891C36.2469 28.8045 37.5832 28.776 38.424 27.9289C39.2647 27.0803 39.2932 25.7328 38.4857 24.919L34.3881 20.7453C33.3464 19.7044 32.0347 18.9751 30.6007 18.6395L30.5469 18.6284L34.4213 14.6653C35.232 13.8515 35.2035 12.5025 34.3627 11.6554C33.522 10.8083 32.1841 10.7814 31.375 11.5953L15.5132 27.5869C13.9726 29.1418 13.1667 31.2872 13.1667 33.659C13.1667 36.0308 13.9726 38.2443 15.5132 39.796Z",
    fill: "#E7A41F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8487 47.1222C22.5728 46.9682 22.3201 46.7757 22.0982 46.5507C19.9972 44.4401 17.8866 42.339 15.7902 40.2221C12.641 37.0427 12.1454 32.4052 14.5457 28.6321C14.9293 28.0553 15.3747 27.5223 15.8742 27.0424L31.1106 11.7743C32.1002 10.7832 33.4824 10.742 34.4023 11.6682C35.289 12.5597 35.2367 13.972 34.2788 14.9394C33.0612 16.1681 31.8421 17.3936 30.6229 18.6207C30.558 18.8138 30.4012 18.9373 30.2667 19.0751C28.9002 20.4621 27.4958 21.8127 26.1484 23.2202C25.9727 23.4039 25.7336 23.5147 25.5594 23.7032C23.3063 25.9562 21.0263 28.184 18.8049 30.4672C17.0078 32.3149 17.068 35.119 18.9126 37.0016C20.9836 39.1169 23.091 41.1974 25.1842 43.2937C25.2902 43.3998 25.3995 43.5027 25.5072 43.6072C26.2482 44.087 26.2577 45.5864 25.7969 46.253C25.2887 46.9892 24.6252 47.4405 23.6863 47.4057C23.3712 47.3962 23.1116 47.2695 22.8487 47.1222Z",
    fill: "#070706"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_46",
    x: 0,
    y: 0.912292,
    width: 60,
    height: 60.2502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4_46"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLc);
export default __webpack_public_path__ + "static/media/lc.10b15e1f635479a8aee37a18caf20c10.svg";
export { ForwardRef as ReactComponent };